const TECHNOLOGY_TYPES = {


    CREATE_TECHNOLOGY_CATEGORY:"CREATE_TECHNOLOGY_CATEGORY",
    CREATE_TECHNOLOGY_CATEGORY_LOADING:"CREATE_TECHNOLOGY_CATEGORY_LOADING",
    CREATE_TECHNOLOGY_CATEGORY_SUCCESS:"CREATE_TECHNOLOGY_CATEGORY_SUCCESS",
    CREATE_TECHNOLOGY_CATEGORY_ERROR:"CREATE_TECHNOLOGY_CATEGORY_ERROR",
    CREATE_TECHNOLOGY_CATEGORY_RESET:"CREATE_TECHNOLOGY_CATEGORY_RESET",

    GET_TECHNOLOGY_CATEGORY:"GET_TECHNOLOGY_CATEGORY",
    GET_TECHNOLOGY_CATEGORY_LOADING:"GET_TECHNOLOGY_CATEGORY_LOADING",
    GET_TECHNOLOGY_CATEGORY_SUCCESS:"GET_TECHNOLOGY_CATEGORY_SUCCESS",
    GET_TECHNOLOGY_CATEGORY_ERROR:"GET_TECHNOLOGY_CATEGORY_ERROR",
    GET_TECHNOLOGY_CATEGORY_RESET:"GET_TECHNOLOGY_CATEGORY_RESET",

    UPDATE_TECHNOLOGY_CATEGORY:"UPDATE_TECHNOLOGY_CATEGORY",
    UPDATE_TECHNOLOGY_CATEGORY_LOADING:"UPDATE_TECHNOLOGY_CATEGORY_LOADING",
    UPDATE_TECHNOLOGY_CATEGORY_SUCCESS:"UPDATE_TECHNOLOGY_CATEGORY_SUCCESS",
    UPDATE_TECHNOLOGY_CATEGORY_ERROR:"UPDATE_TECHNOLOGY_CATEGORY_ERROR",
    UPDATE_TECHNOLOGY_CATEGORY_RESET:"UPDATE_TECHNOLOGY_CATEGORY_RESET",

    DELTE_TECHNOLOGY_CATEGORY:"DELTE_TECHNOLOGY_CATEGORY",
    DELTE_TECHNOLOGY_CATEGORY_LOADING:"DELTE_TECHNOLOGY_CATEGORY_LOADING",
    DELTE_TECHNOLOGY_CATEGORY_SUCCESS:"DELTE_TECHNOLOGY_CATEGORY_SUCCESS",
    DELTE_TECHNOLOGY_CATEGORY_ERROR:"DELTE_TECHNOLOGY_CATEGORY_ERROR",
    DELTE_TECHNOLOGY_CATEGORY_RESET:"DELTE_TECHNOLOGY_CATEGORY_RESET",



    
    CREATE_TECHNOLOGY:"CREATE_TECHNOLOGY",
    CREATE_TECHNOLOGY_LOADING:"CREATE_TECHNOLOGY_LOADING",
    CREATE_TECHNOLOGY_SUCCESS:"CREATE_TECHNOLOGY_SUCCESS",
    CREATE_TECHNOLOGY_ERROR:"CREATE_TECHNOLOGY_ERROR",
    CREATE_TECHNOLOGY_RESET:"CREATE_TECHNOLOGY_RESET",

    GET_TECHNOLOGY:"GET_TECHNOLOGY",
    GET_TECHNOLOGY_LOADING:"GET_TECHNOLOGY_LOADING",
    GET_TECHNOLOGY_SUCCESS:"GET_TECHNOLOGY_SUCCESS",
    GET_TECHNOLOGY_ERROR:"GET_TECHNOLOGY_ERROR",
    GET_TECHNOLOGY_RESET:"GET_TECHNOLOGY_RESET",

    UPDATE_TECHNOLOGY:"UPDATE_TECHNOLOGY",
    UPDATE_TECHNOLOGY_LOADING:"UPDATE_TECHNOLOGY_LOADING",
    UPDATE_TECHNOLOGY_SUCCESS:"UPDATE_TECHNOLOGY_SUCCESS",
    UPDATE_TECHNOLOGY_ERROR:"UPDATE_TECHNOLOGY_ERROR",
    UPDATE_TECHNOLOGY_RESET:"UPDATE_TECHNOLOGY_RESET",

    DELTE_TECHNOLOGY:"DELTE_TECHNOLOGY",
    DELTE_TECHNOLOGY_LOADING:"DELTE_TECHNOLOGY_LOADING",
    DELTE_TECHNOLOGY_SUCCESS:"DELTE_TECHNOLOGY_SUCCESS",
    DELTE_TECHNOLOGY_ERROR:"DELTE_TECHNOLOGY_ERROR",
    DELTE_TECHNOLOGY_RESET:"DELTE_TECHNOLOGY_RESET",



}

export default TECHNOLOGY_TYPES